import { fetchPlanConstants } from 'actions/flowBlockInput';
import { getPlanId } from 'selectors/constantsModal';

const ROOT_URL = '/webapi/xm/1/plans';

export const CONSTANTS_MODAL_HIDE = 'CONSTANTS_MODAL_HIDE';
export const CONSTANTS_MODAL_SHOW = 'CONSTANTS_MODAL_SHOW';

// Instead of using the existing action type from flowBlockInput (which implies all constants are fetched),
// create our own because we're only fetching 1 constant.
export const SINGLE_CONSTANT_LOAD = 'SINGLE_CONSTANT_LOAD';
export const SINGLE_CONSTANT_LOAD_SUCCESS = `${SINGLE_CONSTANT_LOAD}_SUCCESS`;

export const CONSTANT_CREATE = 'CONSTANT_CREATE';

export const CONSTANT_SAVE = 'CONSTANT_SAVE';
export const CONSTANT_SAVE_SUCCESS = `${CONSTANT_SAVE}_SUCCESS`;
export const CONSTANT_SAVE_FAIL = `${CONSTANT_SAVE}_FAIL`;

export const CONSTANT_DELETE = 'CONSTANT_DELETE';
export const CONSTANT_DELETE_SUCCESS = `${CONSTANT_DELETE}_SUCCESS`;
export const CONSTANT_DELETE_NEW = 'CONSTANT_DELETE_NEW';

export const WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS =
  'WORKFLOWCONSTANTS_FETCH_PLAN_CONSTANTS';
export const WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS_SUCCESS = `${WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS}_SUCCESS`;
export const WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS_FAIL = `${WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS}_FAIL`;

export const hideModal = () => ({ type: CONSTANTS_MODAL_HIDE });

export const create = newConstantName => ({
  type: CONSTANT_CREATE,
  payload: newConstantName,
});

function trySyncGWT() {
  if (window.XM_fireConstantsChangedGWTEvent) {
    window.XM_fireConstantsChangedGWTEvent();
  }
}

/**
 * Fetch a single constant using the constant's ID.
 * @param {String} constantId - the UUID of a constant
 * @return {Function} a Redux thunk that when resolves, tells the reducer to replace the old constant with the new one if needed
 */
// selectedTab parameter would come after constantId if we use it
export const loadConstant = constantId => (dispatch, getState) => {
  const planId = getPlanId(getState());

  dispatch({
    type: SINGLE_CONSTANT_LOAD,
    meta: {
      xmApi: true,
      uri: `${ROOT_URL}/${planId}/constants/${constantId}/?embed=usage`,
      method: 'get',
    },
  });
};

/**
 * Save a single constant to the server.
 * This could be an existing constant, or a completely new one, created by the "create" below.
 * @param {Object} payload The mutated constant object
 */
export const save = payload => (dispatch, getState) => {
  const planId = getPlanId(getState());

  const resultPromise = dispatch({
    type: CONSTANT_SAVE,
    meta: {
      xmWebApp: true,
      uri: `${ROOT_URL}/${planId}/constants`,
      method: 'post',
      params: payload,
    },
  });

  // Separate Promise chain since this is unimportant, don't want to cause React issues if GWT complains:
  const onSuccess = trySyncGWT;
  const onError = () => {
    return dispatch(
      fetchPlanConstants(planId, WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS),
    );
  };
  resultPromise.then(onSuccess, onError);

  return resultPromise;
};

export const showModal = () => (dispatch, getState) => {
  const planId = getPlanId(getState());

  return dispatch(
    fetchPlanConstants(planId, WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS),
  )
    .then(() => dispatch({ type: CONSTANTS_MODAL_SHOW }))
    .catch(() =>
      // Dispatched, but not handled
      dispatch({ type: WORKFLOW_CONSTANTS_FETCH_PLAN_CONSTANTS_FAIL }),
    );
};

export const remove = (constantId, next) => (dispatch, getState) => {
  if (!constantId) {
    dispatch({
      type: CONSTANT_DELETE_NEW,
    });
    if (next) {
      dispatch(loadConstant(next.id));
    }
    return Promise.resolve();
  }

  const planId = getPlanId(getState());

  return dispatch({
    type: CONSTANT_DELETE,
    meta: {
      xmWebApp: true,
      uri: `/webapi/xm/1/plans/${planId}/constants/${constantId}`,
      method: 'del',
    },
  }).then(() => {
    trySyncGWT();
    if (next) {
      dispatch(loadConstant(next.id));
    }
  });
};
